import './index.css';
import { useLink } from 'react-router-stack';
import {
  Header,
  ScreenBackground,
  View,
  Text,
  Card,
  RouteWrapper,
  ChatFloatBtn
} from '../../../component';
import useTheme from '../../../utilities/hooks/theme';
import Constants from '../../../constants';
import I18n from '../../../utilities/locale';
import { staticPagesLink } from '../../../utilities/helper';
import { useSelector } from 'react-redux';

const ContactUs = () => {
  const { MoreTheme } = useTheme();
  const navigate = useLink();
  const { themeType = 'light' } = useSelector((state: any) => state.setting);
  const onPressFaq = (pageUrl: any, title: any) => {
    const url = `${staticPagesLink}${pageUrl}?theme=${themeType}`;
    navigate.push('/iframe_page', {
      url,
      title
    });
  };

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onPressEmail = () => {
    window?.open('mailto:support@igamio.com');
  };

  const labelColor = {
    color: MoreTheme.contactUsLabel
  };

  const valueColor = {
    color: MoreTheme.contactUsValue
  };

  const CardColor = {
    backgroundColor: MoreTheme.contactUsItem
  };

  const customerLabel = {
    color: MoreTheme.contactUsCustomerLabel
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header title="Contact us" onClickBack={onClickBack} />
        <View className={'contact-us-container'}>
          <View className={'contact-us-image'}>
            <Constants.Svgs.ContactPageImage />
          </View>
          <Text className={'contact-us-customer-label'} style={customerLabel}>
            {I18n.t('OurCustomerAvailableLabel')}
          </Text>

          <Card className={'contact-us-card'} style={CardColor}>
            <View className={'contact-us-left-icon'}>
              <Constants.Svgs.ContactEmail />
            </View>
            <View onPress={onPressEmail} className={'contact-us-right-part '}>
              <Text className={'contact-us-label'} style={labelColor}>
                {I18n.t('EmailUs')}
              </Text>
              <Text className={'contact-us-value'} style={valueColor}>
                {'support@igamio.com'}
              </Text>
            </View>
          </Card>
          <Card
            onPress={() => {
              onPressFaq('faqs.html', 'FAQs');
            }}
            style={CardColor}
            className={'contact-us-card'}>
            <View className={'contact-us-left-icon'}>
              <Constants.Svgs.ContactFaq />
            </View>
            <View className={'contact-us-right-part '}>
              <Text className={'contact-us-label'} style={labelColor}>
                {I18n.t('Faq')}
              </Text>
            </View>
          </Card>
        </View>
        <ChatFloatBtn />
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default ContactUs;
